import { Link } from "@remix-run/react"

import routes from "#routes"
import GretasPatchworkIcon from "../logos/gretas-patchwork-icon"
import { Button } from "../ui/button"
import { Icon } from "../ui/icon"
import {
	Sheet,
	SheetClose,
	SheetContent,
	SheetHeader,
	SheetTrigger,
} from "../ui/sheet"
import { TypographyP } from "../ui/typography"

export default function Navigation() {
	return (
		<nav>
			<Sheet>
				<SheetTrigger>
					<Button variant="ghost" size="icon">
						<Icon name="hamburger-menu" size="md" />
					</Button>
				</SheetTrigger>

				<SheetContent
					className="min-w-full bg-primary p-12 text-secondary sm:min-w-[300px]"
					side="left"
				>
					<SheetHeader>
						<Link to={routes.public.base.route()}>
							<SheetClose>
								<GretasPatchworkIcon />
							</SheetClose>
						</Link>
					</SheetHeader>

					<div className="mt-20 flex flex-col gap-8">
						<Link
							to={routes.public.products.route()}
							className="font-script md:text-[18px] xl:text-[24px]"
						>
							<SheetClose>Tienda</SheetClose>
						</Link>

						{/* <Link
							to={routes.public.about_us.route()}
							className="font-script md:text-[18px] xl:text-[24px]"
						>
							<SheetClose>Sobre nosotros</SheetClose>
						</Link> */}

						<Link
							to={routes.public.contact.route()}
							className="font-script md:text-[18px] xl:text-[24px]"
						>
							<SheetClose>Contacto</SheetClose>
						</Link>

						{/* <Link
              to={routes.public.care_tips.route()}
              className="font-script md:text-[18px] xl:text-[24px]"
            >
              <SheetClose>Consejos</SheetClose>
            </Link> */}

						<div className="absolute bottom-12 flex flex-col gap-12">
							<a
								target="_blank"
								rel="noreferrer noopener"
								href={routes.external.instagram}
								className="mt-20 font-script md:text-[18px] xl:text-[24px]"
							>
								<SheetClose>Instagram</SheetClose>
							</a>

							<Link to={routes.private.account.route()}>
								<SheetClose className="flex items-center gap-2">
									<Icon name="avatar" size="lg" />{" "}
									<TypographyP className="!mt-0">Mi cuenta</TypographyP>
								</SheetClose>
							</Link>
						</div>
					</div>
				</SheetContent>
			</Sheet>
		</nav>
	)
}
